import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import routeConfig from 'utils/routeConfig';

import { makeSelectIsAuthenticated } from '../App/selectors';
function PrivateRoute(props) {
  const { component: Component, isAuthenticated, ...rest } = props;
  const uiComponent = isAuthenticated ? (
    <Component {...props} />
  ) : (
    <Redirect
      to={{
        pathname: routeConfig.login,
        state: { from: props.location },
      }}
    />
  );
  return <Route {...rest} render={() => uiComponent} />;
}

PrivateRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  location: PropTypes.any,
  component: PropTypes.any,
};

export function mapDispatchToProps() {
  return {};
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(withConnect)(PrivateRoute);



// WEBPACK FOOTER //
// ./app/containers/PrivateRoute/index.js